export default {"src":"/_next/static/media/fclicon.0c30bd66.svg","height":16,"width":16};